import { Component, ChangeDetectorRef, NgZone } from "@angular/core";
import { MetaTagsService } from "src/app/services/meta-tags.service";
import { SharedService } from "src/app/services/shared.service";
import { TranslationService } from "src/app/i18n/translation.service";
import { Subscription } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";
import { UserService } from "src/app/services/apis/user.service";
import { ResizeService } from "src/app/services/resize.service";
import { RouteLocalizationPipe } from "src/app/pipes/route-localization.pipe";
import { Location } from "@angular/common";
import { MultimediaService } from "src/app/services/apis/multimedia.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent {
  userMenu: any = [
    {
      title: "DASHBOARD.VIEW_PROFILE",
      svg: "assets/svgs/user-new.svg",
      link: "/dashboard/my-profile",
      fill: "#000000",
    },
    {
      title: "DASHBOARD.MY_WALLET",
      svg: "assets/svgs/wallet.svg",
      link: "/dashboard/my-wallet",
      fill: "",
    },
    // {
    //   title: 'Check My Appointments',
    //   svg: 'assets/svgs/whistle-blowing.svg',
    //   link: '/dashboard/apppointment-history',
    // },
    // {
    //   title: 'admin.my-vehicles',
    //   svg: 'assets/svgs/car-black.svg',
    //   link: '/dashboard/my-vehicles',
    // },
    // {
    //   title: 'Statistics',
    //   svg: 'assets/svgs/whistle-blowing.svg',
    //   link: '/dashboard/home',
    // },
    // {
    //   title: 'Help',
    //   svg: 'assets/svgs/whistle-blowing.svg',
    //   link: '/dashboard/help',
    // }
  ];
  $getCurrentBalanceObservable: any = null;
  userData: any = null;
  isUserMenuEnabled: boolean = false;
  isAnnouncmentModalEnabled: boolean = false;
  announcmentData: any = {
    title: "10% CASH BACK",
    subtitle: "On vehicle Inspection",
    desc: "Spend QR 100 & get points",
    btnLink: "/",
    btnTxt: "dashboardrevamp.Get_the_offer",
    img: "https://i.ibb.co/7tyhpJZc/00.png",
  };

  isSideMenuEnabled: boolean = false;
  notifications: any = [
    {
      title: "Notification 1",
      msg: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      link: "/dashboard/my-wallet",
    },
    {
      title: "Notification 2",
      msg: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      link: "/dashboard/my-wallet",
    },
    {
      title: "Notification 3",
      msg: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      link: "/dashboard/my-wallet",
    },
    {
      title: "Notification 4",
      msg: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      link: "/dashboard/my-wallet",
    },
    {
      title: "Notification 5",
      msg: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
      link: "/dashboard/my-wallet",
    },
  ];
  isNotificationListEnabled: boolean = false;
  isEn: boolean = this.TranslationService.getSelectedLanguage() === "en";
  isSmsEnabled: boolean = true;
  isNotificationEnabled: boolean = false;
  isSettingEnabled: boolean = false;
  isRevampEnabled: boolean = false;
  lang: string = "en";
  private routerEventsSubscription: Subscription;
  userDetails: any = null;
  isMainAccount: Boolean = false;

  pageTitle: string = "";
  showContent: Boolean = true;
  isUpdateRequiredPage: boolean = false;

status: any = {
    isAPCenabled: false,
    isWOQODEenabled: false
};  
isProfilePage: boolean = false;
  constructor(
    private SharedService: SharedService,
    private metaTagsService: MetaTagsService,
    private TranslationService: TranslationService,
    private router: Router,
    private UserService: UserService,
    private resizeService: ResizeService,
    private sharedService: SharedService,
    private userService: UserService,
    private routeLocalizationPipe: RouteLocalizationPipe,
    private Location: Location,
    private multimediaService: MultimediaService,
    private cd: ChangeDetectorRef,
    private zone: NgZone
  ) {
    this.isMainAccount = this.userService.isMainAccount();
    this.resizeService.screenWidth$.subscribe((screenWidth) => {
      // this.isNotificationEnabled = false;
      this.isSideMenuEnabled = false;
    });


    
    this.sharedService.userImg$.subscribe((img: any) => {    
      if(img){
        this.imgLoading = true;
      }
    });

    this.sharedService.updateProfile$.subscribe((flag: any) => {
      this.userDetails = this.UserService.getUserData();
      this.userData = this.userService.getUserData();
      this.imgLoading = false;
      // this.cd.detectChanges();
      this.zone.run(() => {
        setTimeout(() => {
          this.cd.detectChanges();
        });
      });
    });

    this.userDetails = this.UserService.getUserData();

    this.SharedService.disableFullLoader();
    this.lang = this.TranslationService.getSelectedLanguage();
    if (typeof window !== "undefined") {
      const url = window.location.href;
      // wallet-history
      const isCurrentPageFromTheBelowPages =
        url.indexOf("dashboard/profile") !== -1 ||
        url.endsWith("/dashboard/wallet");
      this.isRevampEnabled = isCurrentPageFromTheBelowPages ? false : true;
      this.metaTagsService.updateMetaTags({
        title: this.lang === "en" ? "Dashboard | Woqod" : "الرئيسية | وقود",
        description:
          this.lang === "en" ? "Dashboard | Woqod" : "الرئيسية | وقود",
        keywords: ["Woqod 1", "Woqod 2"],
      });
    }

    this.routerEventsSubscription = this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        //
        this.renewBalanceAPI(false);
        this.sharedService.balance$.subscribe((balance: any) => {
          if(balance) this.renewBalanceAPI();
        });
        //
        if (typeof window !== "undefined") {
          const url = this.Location.path();
          this.isUpdateRequiredPage =
            (url || "").toLowerCase().indexOf("/my-profile-required") !== -1;

          this.isProfilePage = (url || "").toLowerCase().indexOf("/my-profile") !== -1;

        }

        const newLang = this.TranslationService.getSelectedLanguage();
        const isThereAneedToFlush = newLang !== this.lang;
        if (isThereAneedToFlush) this.showContent = false;
        this.lang = newLang;
        const url = event?.urlAfterRedirects;
        const isRTL = !url.startsWith("/en");
        this.isEn = !isRTL;
        this.handlePageTitle(url);
        setTimeout(() => {
          if (isThereAneedToFlush) this.showContent = true;
        });
        this.status = await this.multimediaService.getAppointmentEnabilityStatus();        
      }
    });
  }

  imgLoading: boolean = false;
  loaderEnabledAmount: boolean = true;
  currentBalanceStopped: boolean = false;

  isFirstTimeToLoad: boolean = true;

  renewBalanceAPI(force: boolean = true) {
    if(typeof window !== "undefined"){
      if(window.location.pathname !== '/en' && window.location.pathname !== '/ar'){

        if(this.isFirstTimeToLoad) this.loaderEnabledAmount = true;
        this.$getCurrentBalanceObservable = this.multimediaService.getCurrentBalance({}).subscribe((results: any) => {
          this.getCurrentBalance(results);
          this.isFirstTimeToLoad = false;
        }, (error)=>{
          this.currentBalanceStopped = true;
          this.isFirstTimeToLoad = false;
        });
      }
    }
  }

  ngOnInit() {
    this.userData = this.userService.getUserData();
  }

  ngOnDistroy(){
    this.$getCurrentBalanceObservable.unsubscribe();
  }

    formatAmount(amount: any): string {
  if (!amount) return "";
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

get maskedAmount(): string {
  const real = this.userWalletAmmount?.result?.toString() || "";
  return "*".repeat(real.length);
}

get formattedAmount(): string {
  return this.formatAmount(this.userWalletAmmount?.result) || '0';
}


  maskMobileNumber(number: string): string {
  if (!number || number.length < 12) return number;

  const start = number.slice(0, 4); // +974
  const masked = '****';
  const end = number.slice(8);     // keep last 4 digits

  return `${start}${masked}${end}`;
}

  isIconClicked = false;
  isIconClicked2 = false;
  timeoutId: any; // To store the timeout reference
  toggleIcon() {
    this.isIconClicked = !this.isIconClicked;

    // Clear any existing timeout if the icon is clicked again before the timeout ends
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Set a timeout to revert `isIconClicked` to false after 5 minutes (300,000 milliseconds)
    if (this.isIconClicked) {
      this.timeoutId = setTimeout(() => {
        this.isIconClicked = false;
        // Update the UI by triggering Angular's change detection
      }, 10000); // 5 minutes = 300,000 milliseconds
    }
  }

  toggleIcon2() {
    this.isIconClicked2 = !this.isIconClicked2;
  }

  userWalletAmmount: any = "";

  getCurrentBalance(response: any) {
    this.currentBalanceStopped = false;    
    this.loaderEnabledAmount = false;
    this.userWalletAmmount = response;
    this.sharedService.balanceResponse$.next(response);
    // this.userWalletAmmount.isSuccess = false;
  }

  handlePageTitle(pageLink: string) {
    if (
      pageLink.includes("/dashboard/my-vehicle-apc") ||
      pageLink.includes("/dashboard/woqod-service-inspection-apc") ||
      pageLink.includes("/dashboard/service-picker-apc") ||
      pageLink.includes("/dashboard/service-inspection-date-apc") ||
      pageLink.includes("/dashboard/service-inspection-date-update-apc") ||
      pageLink.includes("/booking-summary-apc") ||
      pageLink.includes("/booking-summary-apc-update") ||
      pageLink.includes("/dashboard/booking-confirm-apc")
    ){
      this.pageTitle = "Auto_Care";
    } else if (
      pageLink.includes("/dashboard/my-vehicle") ||
      pageLink.includes("/dashboard/woqod-service-inspection") ||
      pageLink.includes("/dashboard/service-picker") ||
      pageLink.includes("/dashboard/service-inspection-date") ||
      pageLink.includes("/booking-summary") ||
      pageLink.includes("/dashboard/booking-confirm")
    ){
      this.pageTitle = "PRODUCT_AND_SERVICE.WOQODE";
    }else if (pageLink.includes("/dashboard/dashboard"))
      this.pageTitle = "admin.Dashboard";
    else if (pageLink.includes("/dashboard/my-profile"))
      this.pageTitle = "admin.my-profile";
    else if (pageLink.includes("/dashboard/my-vehicles"))
      this.pageTitle = "admin.my-vehicles";
    else if (pageLink.includes("/dashboard/appointment-history"))
      this.pageTitle = "admin.appointment-history";
    else if (pageLink.includes("/dashboard/my-wallet"))
      this.pageTitle = "admin.my-wallet";
    else if (
      pageLink.includes("/dashboard/woqod-e-tag") ||
      pageLink.includes("/dashboard/etag-add") ||
      pageLink.includes("/dashboard/booking-summary")
    )
      this.pageTitle = "admin.woqod-e-tag";
    else if (pageLink.includes("/dashboard/helps"))
      this.pageTitle = "admin.helps";
    else if (
      pageLink.includes("/dashboard/wallet-history") ||
      pageLink.includes("/dashboard/topup-buy") ||
      pageLink.includes("/dashboard/topup-checkout") ||
      pageLink.includes("/dashboard/topup-confirmation") ||
      pageLink.includes("/dashboard/wallet-graph")
    )
      this.pageTitle = "admin.my-wallet";
  }

  isLinkActive(keyword: string) {
    const url = typeof window !== "undefined" ? window.location.href || "" : "";
    return url.includes(keyword);
  }

  setLang() {
    this.TranslationService.setLanguage(this.isEn ? "ar" : "en");
    setTimeout(() => {
      this.isEn = this.TranslationService.getSelectedLanguage() === "en";
    });
  }

  getUserImage() {
    const defaultImage = "assets/images/userDefault.jpg";
    if(this.imgLoading) return "assets/images/default-img.gif";
    const img = this.userData?.imageID || "";
    return img
      ? this.sharedService.isValidImage(img)
        ? img
        : defaultImage
      : defaultImage;
  }

  getFullName() {
    const firstName = this.userData?.firstName || "";
    const lastName = this.userData?.lastName || "";
    return firstName && lastName
      ? firstName + " " + lastName
      : firstName
      ? firstName
      : lastName
      ? lastName
      : "---";
  }

  clickOnMenuItem() {
    this.isUserMenuEnabled = false;
  }

  logout() {
    this.multimediaService.logout().subscribe((response) => {
      if(response?.isSuccess){
        this.userService.clearUserData();
        this.userData = null;
        // this.getProfileByTokenResponse = null;
        // this.validateOTPPhoneResponse = null;
        // this.getTokenByB2CResponse = null;
        // this.registerUserPhoneResponse = null;
        // this.registerUserEmailResponse = null;
        this.userDetails = null;
        this.isUserMenuEnabled = false;
        // this.isLoginByPhoneNumberEnabled = true;
        // this.mobileNumber = "+97430048341";
        // this.email = "";
        // this.otp = null;
        // this.sendOTPFormSubmitted = false;
        // this.errorMsg = "";
        // this.isSendOTPEnabled = false;
        // this.isLoadingEnabled = false;
        // this.router.navigate([this.routeLocalizationPipe.transform("/")]);
        // const base = (
        //   document.querySelector("base")?.getAttribute("href") || "/"
        // ).replace(/\/+$/, "");
        // const lang = this.lang.replace(/^\/+/, "");

        setTimeout(() => {
              this.router.navigate([this.routeLocalizationPipe.transform("")]);
        });


        // setTimeout(() => {
        //   // window.location.replace(`${base}/${lang}`);
        //   //
        //   // empty login pop up
        //   this.router.navigate([`/${this.lang}`]);
        //   // .then(() => {
        //   //   this.sharedService.triggerProfileUpdate();
        //   // });      
        // });
      }else{
        // error logout
      }
    }, (error:any) => {
      // error logout
    });    
  }

  closeMenuInMobile(){
    this.isSideMenuEnabled = false;
  }


  isDdlEnabled: boolean = false;
  fireCloseAnimation: boolean = false;
  isImageInEditMode: boolean = false;
  isPersonalInEditMode: boolean = false;
  isAddressInEditMode: boolean = false;
  
  text() {
    // this.isImageInEditMode = true;
    // this.isPersonalInEditMode = true;
    // this.isAddressInEditMode = true;
    this.toggleDDL();
    // 
    const ele: any = document.querySelector("#edit-profile-trigger");
    if(ele) ele.click();
  }

  toggleDDL() {
    if (this.isDdlEnabled) {
      this.fireCloseAnimation = true;
      setTimeout(() => {
        this.isDdlEnabled = false;
        this.fireCloseAnimation = false;
      }, 300);
    } else {
      this.isDdlEnabled = true;
    }
  }

}
